import { useSelector } from 'react-redux';
import { useGetMembersWithExtensionsQuery } from '../services/VoipService';
import { getLoggedInUser, getLoggedInUserOrganization } from '../selectors/userSelectors';

/**
 * Resolves whether the logged-in member is a VoIP user.
 *
 * The Redux `state.user.users[loggedInId].extensions` array is unreliable for
 * this gate — minimal user payloads from group/role list endpoints overwrite
 * it, which causes the phone icon (and other VoIP UI) to disappear until
 * refresh. The members-with-extensions endpoint lives in its own RTK Query
 * cache and is not contaminated by those reducers, so we use it as the
 * authoritative source.
 */
export default function useIsVoipUser() {
  const currentUser = useSelector(getLoggedInUser);
  const organization = useSelector(getLoggedInUserOrganization);
  const isVoipEnabled = !!organization?.isVoipEnabled;
  const { data } = useGetMembersWithExtensionsQuery(undefined, { skip: !isVoipEnabled });
  const members = Array.isArray(data?.objects) ? data.objects : [];
  const hasExtension = currentUser?.id != null
    && members.some((m) => Number(m.userId) === Number(currentUser.id) && !!m.extension);

  return {
    isVoipEnabled,
    hasExtension,
    isVoipUser: isVoipEnabled && hasExtension,
  };
}
